document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.blc-carousel-wrap').forEach(function (wrap) {
    var viewport = wrap.querySelector('.blc-track-viewport');
    var track = wrap.querySelector('.blc-track');
    var prevBtn = wrap.querySelector('.blc-arrow--prev');
    var nextBtn = wrap.querySelector('.blc-arrow--next');

    if (!viewport) return;

    var scrollAmount = function () {
      var slide = track.querySelector('.blc-slide');
      var slideWidth = slide ? slide.getBoundingClientRect().width + 20 : 220;
      return slideWidth * 2;
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (track) track.classList.add('blc-paused');
        viewport.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (track) track.classList.add('blc-paused');
        viewport.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }
  });

  // Pause autoplay while editing in the Shopify theme editor so merchants
  // can clearly see the block they're currently working on.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (event) {
      var track = event.target.closest('.blc-track');
      if (track) track.classList.add('blc-paused');
    });
    document.addEventListener('shopify:block:deselect', function (event) {
      var track = event.target.closest('.blc-track');
      if (track) track.classList.remove('blc-paused');
    });
  }
});
